import dompurify from 'dompurify'

export const sanitize = (html: string) => {
  return dompurify.sanitize(html, {
    ADD_ATTR: ['target', 'rel'],
    ALLOWED_TAGS: ['p', 'strong', 'em', 'u', 'h1', 'h2', 'a']
  })
}
